/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { LogLevel } from '@msdyn365-commerce/telemetry-internal';
import * as React from "react";
//import { ParallaxProvider, Parallax } from 'react-scroll-parallax';


//import { IObrienDefaultPageData } from "./obrien-default-page.data";
import { IObrienDefaultPageProps } from "./obrien-default-page.props.autogenerated";

/**
 *
 * CoreComponent component
 * @extends {React.PureComponent<IObrienDefaultPageProps>}
 */
 class ObrienDefaultPageContainer extends React.PureComponent<IObrienDefaultPageProps<{}>> {
  constructor(props: IObrienDefaultPageProps<{}>) {
      super(props);
  }

  public render(): JSX.Element {
      const { slots, telemetry, id, typeName } = this.props;

      let skipToMainText = this.props.config && this.props.config.skipToMainText;
      telemetry.log(LogLevel.Debug, "DefaultPageContainer rendering for '{id}/{typeName}'", { values: [id, typeName] });

      if (!skipToMainText) {
          skipToMainText =
              this.props.context.app && this.props.context.app.platform ? this.props.context.app.platform.skipToMainText : '';
      }

      return (
        <React.Fragment>
          {slots && slots.subheader && (
            <div>
              <div className="product">

                <div className="white-back-fix">
              
                <header className="par-header">
                  {slots &&
                    slots.header &&
                    slots.header.map((children: React.ReactNode) => {
                      return children;
                    })}
                </header>
                <div id="subheader">
                  {slots.subheader.map((children: React.ReactNode) => {
                    return children;
                  })}
                </div>
                </div>

                <section className="overlay-img">
                
                  <main id="main">
                    {slots &&
                      slots.primary &&
                      slots.primary.map((children: React.ReactNode) => {
                        return children;
                      })}
                  </main>
                
                
                  {slots && slots.subfooter && (
                    <div id="subfooter">
                      {slots.subfooter.map((children: React.ReactNode) => {
                        return children;
                      })}
                    </div>
                  )}
                  <footer>
                    {slots &&
                      slots.footer &&
                      slots.footer.map((children: React.ReactNode) => {
                        return children;
                      })}
                  </footer>
                </section>
                
              </div>
            </div>
          )}
          {slots && !slots.subheader && (
            <div>
              <div className="product">
                <header>
                  {slots &&
                    slots.header &&
                    slots.header.map((children: React.ReactNode) => {
                      return children;
                    })}
                </header>
                <section className="not-parallax">
                  <main id="main">
                    {slots &&
                      slots.primary &&
                      slots.primary.map((children: React.ReactNode) => {
                        return children;
                      })}
                  </main>
                  {slots && slots.subfooter && (
                    <div id="subfooter">
                      {slots.subfooter.map((children: React.ReactNode) => {
                        return children;
                      })}
                    </div>
                  )}
                  <footer>
                    {slots &&
                      slots.footer &&
                      slots.footer.map((children: React.ReactNode) => {
                        return children;
                      })}
                  </footer>
                </section>
              </div>
            </div>
          )}
      </React.Fragment>
      );
  }
}

export default ObrienDefaultPageContainer;
